import { useEffect } from "react";
import { _single, _THConstants } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import { DropDown } from "../../../theme/Component/DropDown";
import { THConstantsValue } from "../Componentes/THConstantsValue";


interface Props {
    appName?: string;
}

export const THConstants = ({ appName }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_THConstants)

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Parametrica", MODAL_SM);
    const modalTHC = useModal("Valores Parametricos", MODAL_LG);
    const head = [
        { title: 'ID', property: "IDTHConstants" },
        { title: 'Nombre', property: 'Name' },
        { title: 'Descripción', property: 'Description' },
        { title: 'Código', property: 'Code' },
        { title: 'Grupo', property: 'GroupCode' },
    ]

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        const Props = {
            GroupCode: appName,
            State: 1,
        }
        instance.getTHConstantsCatalogPorPropiedades(Props, null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const agregarItem = () => {
        setBean({
            GroupCode: appName,
            State: 1,
        });
        modal.open("Agregar tabla parametrica");

    }

    const eliminaritem = () => {
        const x = { ...bean, State: 2 }
        updateItem(x);
    }

    const updateItem = (obj: any) => {
        instance.updateTHConstants(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => { toast.error(err) });
    }

    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Tabla") } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete() , evento: () => { modalC.open(); } },
            { titulo: 'Parametricas', icono: 'ri-list-check', visible: true, evento: () => { modalTHC.open(); } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    const actionsDropDown = [
        { id: 1, name: 'Borrar Cache', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={eventChange}></DropDown>
                </div>
            </div>
        )
    }

    const eventChange = (e: any) => {

        if (e.id === 1) {
            instance.cleanSuppConstantsValues(_single.getAccountID()).then(
                (resp: any) => {
                    toast.success("Cahce actualizada.");
                }
            ).catch(err => { toast.error(err) })
        }

    }

    return (
        <>
            <BasicPage titulo={`Parametricas del sistema ${appName ? `- ${appName}` : ""}`}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable headButtons={buttons()} listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setBean} />
                    </div>
                </div>
            </BasicPage>

            <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={eliminaritem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { updateItem(bean) }}>
                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Nombre</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, 'Name': e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">AppName</label>
                        <input disabled={appName != undefined} type="text" className="form-control" value={bean.GroupCode} onChange={(e) => { setBean({ ...bean, 'GroupCode': e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Code</label>
                        <input type="text" className="form-control" value={bean.Code} onChange={(e) => { setBean({ ...bean, 'Code': e.target.value }) }} />
                    </div>
                    <div className="col-md-12">
                        <label className="form-label">Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, 'Description': e.target.value }) }}></textarea>
                    </div>

                </div>
            </Modal>

            <Modal modal={modalTHC.modal} updateModal={modalTHC.setModal}>
                <div className="row">
                    <div className="col-md-12">
                        <THConstantsValue idTHConstants={bean.IDTHConstants} />
                    </div>
                </div>
            </Modal>
        </>
    )
}